import { Icon } from '@chakra-ui/react';

export const Download = (props) => (
  <Icon viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5614 6.29945L8.75 9.18428V1.25C8.75 0.835786 8.41421 0.5 8 0.5C7.58579 0.5 7.25 0.835786 7.25 1.25V9.18428L4.43855 6.29945C4.15027 6.00202 3.67545 5.9946 3.37802 6.28288C3.08059 6.57116 3.07317 7.04598 3.36145 7.34341L7.46145 11.5577C7.75612 11.8617 8.24388 11.8617 8.53855 11.5577L12.6386 7.34341C12.9268 7.04598 12.9194 6.57116 12.622 6.28288C12.3245 5.9946 11.8497 6.00202 11.5614 6.29945ZM1.25 14C0.835786 14 0.5 14.3358 0.5 14.75C0.5 15.1642 0.835787 15.5 1.25 15.5H14.75C15.1642 15.5 15.5 15.1642 15.5 14.75C15.5 14.3358 15.1642 14 14.75 14H1.25Z"
      fill="currentColor"
    />
  </Icon>
);
